import { IconsLibrary } from '@elotech/components';
import { library } from '@fortawesome/fontawesome-svg-core';

import * as icons from './Icons';

library.add(icons);
library.add(IconsLibrary);
